var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
  'v-select-wrapper',
  _vm.active || _vm.isFocused ? 'active' : '',
  _vm.classModify,
]},[_c('label',[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('date-picker',{attrs:{"lang":"pt-br","value":_vm.value,"disabled":_vm.disabled,"name":_vm.name,"format":_vm.format,"placeholder":""},on:{"input":function($event){return _vm.$emit('input', $event)},"focus":_vm.onFocus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }